import { render, staticRenderFns } from "./IOPSVolumeToggle.vue?vue&type=template&id=737fae54&"
import script from "./IOPSVolumeToggle.vue?vue&type=script&lang=js&"
export * from "./IOPSVolumeToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737fae54')) {
      api.createRecord('737fae54', component.options)
    } else {
      api.reload('737fae54', component.options)
    }
    module.hot.accept("./IOPSVolumeToggle.vue?vue&type=template&id=737fae54&", function () {
      api.rerender('737fae54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/launchService/IOPSVolumeToggle.vue"
export default component.exports